import "@hotwired/turbo-rails"
import '@stripe/stripe-js';

import "bootstrap";

document.addEventListener('click', event => {
  const elem = event.target.closest('.switch-class');
  if (!elem) {
    return;
  }
  document.querySelectorAll(elem.dataset.target).forEach(target => {
    target.classList.toggle(elem.dataset.class);
  });
});
